/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Url_Enter_ValidInputs */

const en_common_url_enter_valid = /** @type {(inputs: Common_Url_Enter_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid website URL (e.g., example.com)`)
};

const es_common_url_enter_valid = /** @type {(inputs: Common_Url_Enter_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa una URL válida (ej., example.com)`)
};

/**
* | output |
* | --- |
* | "Please enter a valid website URL (e.g., example.com)" |
*
* @param {Common_Url_Enter_ValidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_url_enter_valid = /** @type {((inputs?: Common_Url_Enter_ValidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Url_Enter_ValidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_url_enter_valid(inputs)
	return en_common_url_enter_valid(inputs)
});